<!-- 日记账高级表格实现方案 -->
<template>
  <div id = "c-vxe-grid">
    <vxe-grid
      v-bind="gridOptions"
      ref="xTable"
      :footer-method="footerMethod"
      @checkbox-all="selectAllEvent"
      @checkbox-change="selectChangeEvent"
      :checkbox-config="{labelField: 'name', checkMethod}"
      :row-class-name="rowClassName"
    >
      <!-- 渲染表头筛选 -->
      <!-- 日期筛选 -->
      <template #date_filter="{ column, context }">
        <div class = "c-vxe-dateFilter">
          <span v-for="(option, index) in column.filters" class='c-vxe-dateFilter-date' :key='index'>
          	<el-date-picker
             v-model="option.data"
             type="date"
             size='mini'
             clearable
             @change='context.changeOption($event, !!option.data, option)'
             style='width: 150px;'
             placeholder="请选择">
           </el-date-picker>
           <span v-if='index===0' style='margin: 0 5px;'> - </span>
          </span>
        </div>
      </template>
      <!-- 文本框筛选 -->
      <template #text_filter="{ column, context }">
         <div class = "c-vxe-dateFilter">
           <span  v-for="(option, index) in column.filters" :key='index'>
           	<el-input
               size='mini'
               v-model="option.data"
               clearable
               @input="context.changeOption($event, !!option.data, option)"
               style='width: 320px;'
               placeholder='请输入关键字查询'
             >
             </el-input>
           </span>
         </div>
      </template>
      <!-- 数值筛选 -->
      <template #number_filter="{ column, context }">
         <div class = "c-vxe-dateFilter">
           <span  v-for="(option, index) in column.filters" :key='index'>
           	<el-input
               size='mini'
               clearable
               v-model="option.data"
               @input="context.changeOption($event, !!option.data, option)"
               style='width: 120px;'
               placeholder='请输入数值查询'
             >
           	</el-input>
           	<span v-if='index===0' style='margin: 0 5px;'> - </span>
           </span>
         </div>
      </template>
      <!-- 下拉&&按钮筛选 -->
      <template #select_filter="{ column, context }">
         <div class = "c-vxe-dateFilter">
           <span  v-for="(option, index) in column.filters" :key='index'>
           	<el-select
               v-model="option.data"
               placeholder="请选择"
               @change='context.changeOption($event, !!option.data, option)'
               size='small'
               :ref="'select' + column.property"
               popper-class="c-vxe-selectDropdown"
               multiple
               filterable
               clearable
             >
              <el-option
                v-for="i in column._own.optionList"
                :key="i.id"
                :label="i.optionName"
                :value="i.id">
              </el-option>
              <div class="c-vxe-selectFooter">
                <accBtn text="收起" size="mini" type="3" width="80px" @click="handleFilterData('select' + column.property)"></accBtn>
              </div>
            </el-select>
           </span>
         </div>
      </template>
      <!-- 筛选渲染  end************************************************************** -->
      <!-- 渲染表格数据 -->
      <template v-for="item in gridOptions.columns" v-slot:[item.value]="{ row }">
        <div :key="item.id" class="c-columns_wrapper">
          <!-- 单选框渲染 -->
          <span v-if='(item.type==="select" || item.type==="btn")&&!item.isChioce'>
          	<span
              :style='{ backgroundColor:styleColor(item,row,"1")}'
              class="c-select c-singleSelect-color"
              v-if='styleColor(item,row,"1")'
            >
              {{row[item.value]?row[item.value].name:""}}
            </span>
          	<span v-else class="c-select">{{row[item.value]?row[item.value].name:""}}</span>
          </span>
          <!-- 多选框渲染 -->
          <span v-else-if='(item.type==="select" || item.type==="btn")&&row[item.value]'>
            <span
              v-for='(j,index) in row[item.value].color'
              class="c-select c-multipleSelect"
              :style='{ color:styleColor(item,j,"2") }'
              :key='j.id'
            >
              {{j.name}}
            </span>
          </span>
          <!-- 数值渲染 -->
          <span v-else-if='item.type==="number"'>{{calculation(row,item.value)}}{{returnFloat(row[item.value],item.decimalNum,item.decimalNum_s)}}</span>
          <!-- 图片渲染 -->
          <span v-else-if='item.type==="img"&&row[item.value]'>
            <el-image
              v-for='(i,index) in row[item.value].imgList'
              :key='index'
              style='width: 30px;height:30px;margin-right: 10px;'
              :src="i.url"
              :preview-src-list="[i.url]">
            </el-image>
          </span>
          <!-- 其他 -->
          <span v-else>
            <!-- 修改数据标识 -->
            <span
              class='c-vxe-isEditHit'
              v-if='item.id==2&&row.isBeginning!==1&&row.isUpdate===1'
              @click="openEditDialog(row)"
            >
              改
            </span>
            <span v-html="formartValue(row,item.value)"></span>
            <!-- 内部转账标识 -->
            <span  
              v-if='item.id==2&&row.isBeginning!==1&&row.transfer===0' 
              class="c-vxe-transfer" 
              title="内部转账"
              :style = "{ 
                color: row.debitMoney>0?'#269D7B':'orange', 
                background: row.debitMoney>0?'rgba(38, 157, 123, .1)':'rgba(255,165,0,.1)'
              }"
            >
              {{ row.debitMoney>0?"转入":"转出" }}
            </span>
          </span>
        </div>
      </template>
      <!-- 表格末尾操作 -->
      <template v-slot:operation="{ row }">
        <div  v-if='!(row.isBeginning===0?false:true)' class="c-vxe-operation" >
           <span class="c-vxe-operation-edit" @click="$emit('editRow',row)">编辑</span>
           <span
            v-if="row.button.length"
            class="c-vxe-operation-del"
            @click="$emit('delRowData',row)"
          >删除</span>
           <c-mark size="16px" :rows="row" @saveMark="saveMark($event,row)"></c-mark>
        </div>
      </template>
      <!-- 渲染表格数据  end************************************-->

      <!-- 自定义重置所有条件-->
      <template #toolbar_buttons>
       <!-- <vxe-input
          v-model="filterName"
          type="search"
          placeholder="全表搜索"
          @keyup="searchEvent1"
          class="c-vxe-globalSearch"
          size="mini"
          @clear = "searchEvent1"
          clearable
        >
        </vxe-input> -->
        <accBtn text = "重置所有筛选" size="mini" type="3" @click="resetAllFilter"></accBtn>
      </template>
    </vxe-grid>

    <!-- 查看修改数据弹框 -->
    <edit-table ref = "editTableRef"></edit-table>
  </div>
</template>

<script>
  import {currencys} from '@/assets/utils/currencyFormat'
  import cMark from "./c-mark.vue"
  import editTable from "./c-edit-logList.vue"
  export default {
    props:{
      table:[Object]
    },
    components:{
      cMark,editTable
    },
    data () {
      return {
        currencys,
        filterName:"",
        gridOptions: {
          loading:false,
          border: true,
          showFooter:true,
          resizable: true,
          showHeaderOverflow: true,
          showOverflow: true,
          id:"1",
          height: 700,
          align: 'left',
          toolbarConfig: {
            custom: true,
            slots: {
              buttons: 'toolbar_buttons',
            }
          },
          customConfig: { // 自定义显示列
            storage: true,
            checkMethod: this.checkColumnMethod
          },
          sortConfig: {
            trigger: 'default',
            remote: false,
            sortMethod:this.sortMethod
          },
          columns: [],
          data: [],
        },
        allData: {},
        footerMethod:()=>{},
        copyData:[],
        headerValve:[],
      }
    },
    watch:{
      table:{
        handler(val) {

        },
        deep:true,
        immediate:true
      }
    },
    methods:{
      // 获取表格所需数据
      getAllData(val) {
        this.gridOptions = Object.assign({},this.gridOptions,{
          columns: val.config,
          height: val.tableHeight?val.tableHeight:700,
          data: val.data,
          id: val.id + "",
          loading: val.loading,
        })
        this.copyData = this.$lodash.cloneDeep(val.data);
        this.footerMethod = val.footerMethod?val.footerMethod:()=>{};
        val.config.forEach((item,index)=>{
          if(index > 0 && index < val.config.length-1) {
            this.headerValve.push(item.value);
          }
        })
        console.time("rander");
        this.$nextTick(()=>{
          console.timeEnd("rander");
        })
      },
      // 全表搜索  处理数字和全局筛选和局部筛选的冲突
       searchEvent1 () {
        let filterName = this.filterName + "";
        if (filterName) {
          filterName = this.filterName.toString().trim().toLowerCase()
          const filterRE = new RegExp(filterName, 'gi')
          const searchProps = this.headerValve;
          const rest = this.copyData.filter(item => {
            let isHaveKey = false;
            searchProps.some(key => {
              let value = "";
              if(typeof item[key] === "object") {
                switch(item[key].customType) {
                  case "1":
                  case "2":
                  case "3":
                    value = item[key].value + "";
                    break;
                  case "4":
                  case "6":   // 下拉&&按钮
                    value = item[key].name + "";
                    break;
                }
              }else {
                value = item[key] + "";
              }
              if(value && value.toString().toLowerCase().indexOf(filterName) > -1) {
                isHaveKey = true;
              }
            })
            return isHaveKey;
          })
          this.gridOptions.data = rest.map(row => {
            const item = this.$lodash.cloneDeep(row);
            searchProps.forEach(key => {
              if(typeof item[key] === "object") {
                let showValue = item[key].value;
                switch(item[key].customType) {
                  case "1":
                  case "2":
                    item[key] = showValue.toString().replace(filterRE, match => `<span class="keyword-lighten">${match}</span>`)
                    break;
                  default:
                    break;
                }
              }else {
                item[key] = item[key].toString().replace(filterRE, match => `<span class="keyword-lighten">${match}</span>`)
              }

            })
            return item
          })
        } else {
          this.gridOptions.data = this.copyData
        }
      },
      // 自定义筛选 收起
      handleFilterData(ref) {
       this.$nextTick(()=>{
          this.$refs[ref][0].blur();
       })
      },
      // 期初高亮
      rowClassName ({ row, rowIndex }) {
        	if(row.isBeginning===1) {
        		return "hightLight_row"
        	}
        	if(row.backgroundColor) {
        		return "hightLight_lastrow"
        	}
      },
      // 自定义显示列
      checkColumnMethod({ column }) {
        let disList = ['#','checkbox','operation','date','summary','debitMoney','creditorMoney','remainingSum'];
        if (disList.includes(column.property)) {
          return false
        }
        return true
      },
      // 重置所有筛选
      resetAllFilter(value) {
        value = value?value:"";
        this.$refs.xTable.clearFilter(value);
      },
      // 期初禁用筛选
      checkMethod ({ row }) {
        return !(row.isBeginning===0?false:true)
      },
      // 选择变化
      selectChangeEvent(val){
      	let idList=[];
      	if(val.selection.length) {
      		val.selection.forEach(i=>{
      			idList.push(i.id);
      		})
      	}else {
      		idList=[];
      	}
      	this.$emit('idList',idList)
      },
      // 全选
      selectAllEvent(val){
      	let data  = val.$table.afterFullData;
      	val.$table.selection = val.$table.selection.filter((a)=>{
      		for (var i = 0; i < data.length; i++) {
      			let x = data[i]
      			if(x.id === a.id){
      		 		return x.id === a.id
      		 	}
      		}
      	})

      	let idList=[];

      	if(val.$table.selection.length) {
      		val.$table.selection.forEach(i=>{
      			idList.push(i.id);
      		})
      	}else {
      		idList=[];
      	}

      	this.$emit('idList',idList)
      },
      // 打开查看修改记录弹框
      openEditDialog(row) {
        this.$refs.editTableRef.getRow(row);
      },
      saveMark(e,row) {
        this.$emit('saveMark',e)
      },
      // 排序方法
      sortMethod({ data, column, property, order }) {
        if(order) {
          let firstObj = data.splice(0,1)
          data.sort((a,b)=>{
            if(typeof a[property]==='object'&&typeof b[property]==='object') {
              return (a[property].value>b[property].value?1:-1)*(order==="asc"?1:-1)
            }else {
              return (a[property]>b[property]?1:-1)*(order==="asc"?1:-1)
            }
          })
        	data.unshift(firstObj[0]);
          // 计算余额
          data.forEach((item,index)=>{
          	if(index<data.length-1) {
             data[index+1].remainingSum = Number(data[index].remainingSum)+Number(data[index+1].debitMoney)-Number(data[index+1].creditorMoney);
            }
          })
        }
        return data;
      },
      // 格式化数据
      formartValue(row,val){
      	if(val==="createUser"&&row.isBeginning===1) {
      		return "";
      	}
      	let value = row[val];
      	if(value&&typeof(value)==="object") {
      		return value.value;
      	}else {
      		return value;
      	}
      },
      //保留两位小数自动补零
      returnFloat(value,num,isHave){
      	if(typeof(value)==="object") {
      		value = value.value;
      	}
      	if(!value || value===Infinity) {
      		return "";
      	}
      	if(!isHave) {
      		let stringified = Math.abs(value);
      		let sign = value < 0 ? '-' : ''
      		let value_s = stringified.toString().split(".");
      		if(value_s[0]!=="") {
      			const digitsRE = /(\d{3})(?=\d)/g
      			let _int=value_s[0];
      			let index =  _int.length % 3;
      			let head = index > 0 ? (_int.slice(0, index) + (_int.length > 3 ? ',' : '')) : '';
      			if(value_s[1]) {
      				return sign + head + _int.slice(index).replace(digitsRE, '$1,') + "."+value_s[1];
      			}else {
      				return sign + head + _int.slice(index).replace(digitsRE, '$1,');
      			}
      		}
      		return value;
      	}else {
      		return currencys(value,"",Number(num));
      	}
      },
      // 自动计算赋值
       makeAllData(data){
         this.allData.debitMoney=!Number(data.debitMoney)?0:Number(data.debitMoney)
         this.allData.creditorMoney=!Number(data.creditorMoney)?0:Number(data.creditorMoney)
         for (var obj in data) {
           if(obj.substring(0, 5) === "value"){
             if(data[obj].customType==="3"){
             let o= obj.replace("value-","field_");
             this.allData[o]=!Number(data[obj].value)?0:Number(data[obj].value)
             }
           }

         }
      },
       // 自动计算
       calculation(data,i){
        this.makeAllData(data);
        for (var obj in data) {
           if(data.isBeginning!==1&&data[obj]&&data[obj].valueType=='1'){
             data[obj].value=eval(data[obj].formula)?eval(data[obj].formula):0;
          }
        }
       },
      // 选择框颜色处理
      styleColor(item,row,t){
      	let obj = item.optionList.find(i=>{
      		if(t==="1") {
      			if(!row[item.value]) {return ""};
      		 	return i.id===row[item.value].id
      		}else {
      			return i.id===row.id;
      		}
      	})
      	return obj?obj.color:"";
      },
    }
  }
</script>

<style lang="less" scoped>
  @import "../../../../assets/css/cashierdiary/vxeGrid.less";
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/c-query-table/newTableList.vue